const checkFitmentFragment = `checkFitmentForSkuBases(skuBases: $skuBases, vehicleBases: $vehicleBases, raceTypes: $raceTypes){
    key
    value {
      skuBase
      vehicleBaseFitment{
        key
        value {
          fits
          isDirectFit
          isDrivelineFit
          isUniversalFit
          shopUrl
        }
      }
      raceTypeFitment{
        key
        value {
          fits
          isDirectFit
          isDrivelineFit
          isUniversalFit
          shopUrl
        }
      }
    }
  }`
  
  const checkFitment = `query checkFitmentForSkuBases($skuBases: [String], $vehicleBases: [Int!], $raceTypes: [Int!]){
  ${checkFitmentFragment}
    }`
  
  export default checkFitment;
  export { checkFitmentFragment };